"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.selector = void 0;
var getIsPlaying = function (state) { return state.detail.videoPlayer.isPlaying; };
var getIsMuted = function (state) { return state.detail.videoPlayer.isMuted; };
var getIsOverlayActive = function (state) { return state.detail.videoPlayer.overlayActive; };
var selector = { getIsPlaying: getIsPlaying, getIsMuted: getIsMuted, getIsOverlayActive: getIsOverlayActive };
exports.selector = selector;
